var WooFilters = {
	
	init:function(){
		
		Debug.log("____ WOO SHOP INIT ____");
		
		
		$(".btn-filter").on("click touchend", function(e){
			if(e.type == 'touchend'){
				$(this).off("click");
			}			
			
			$(".shop-top-widget").addClass("open");

			setTimeout(function(){
				$(".shop-top-widget .shadow").on("click touchend", function(e){
					
					$(".shop-top-widget .shadow").off("click touchend");
					$(".shop-top-widget .btn-close").off("click touchend");
					
					$(".shop-top-widget").removeClass("open");
				});
				
				$(".shop-top-widget .btn-close").on("click touchend", function(e){
					
					$(".shop-top-widget .shadow").off("click touchend");
					$(".shop-top-widget .btn-close").off("click touchend");
					
					$(".shop-top-widget").removeClass("open");
				});
				
			}, 100);

		});

	}
}
$(window).load(function(){
	if($(".btn-filter").length){
		WooFilters.init();
	}
});